import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AuthModule } from '@auth0/auth0-angular';
import { SpAuthGuard } from '@core/guards/auth-guard';

//* bootstrap App ('required modules')
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { FeaturesModule } from './features/features.module';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';

//* App Component
import { AppComponent } from './app.component';
import { ThirdPartyServicesModule } from './core/services/thirdPartyServices.module';
import { ApplicationInsightsModule } from './application-insights/application-insights.module';

//* Modules to import
const modules = [
  BrowserModule,
  FormsModule,
  AppRoutingModule,
  RouterModule,
  BrowserAnimationsModule,
  FormsModule,
  CoreModule,
  SharedModule,
  FeaturesModule,
  AuthModule.forRoot({
    ...environment.auth,
    cacheLocation: 'localstorage',
    useRefreshTokens: true,
    scope: 'openid profile email all',
    httpInterceptor: {
      ...environment.httpInterceptor,
    },
  }),
  ThirdPartyServicesModule,
  ApplicationInsightsModule,
];

@NgModule({
  declarations: [AppComponent],
  imports: modules,
  bootstrap: [AppComponent],
  providers: [SpAuthGuard],
})
export class AppModule {}
